package com.eladfinish.bible.contest.screens.main.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.common.gender.HebrewGender
import com.eladfinish.bible.contest.common.gender.personalizeGender
import com.eladfinish.bible.contest.draggable_item_regular_click
import com.eladfinish.bible.contest.dragging_done
import com.eladfinish.bible.contest.dragging_reset
import com.eladfinish.bible.contest.screens.main.data.ButtonData
import com.eladfinish.bible.contest.screens.main.data.ButtonType
import com.eladfinish.bible.contest.screens.main.data.toButtonData
import com.eladfinish.bible.contest.screens.pairMatching.model.SortableData
import com.eladfinish.bible.contest.ui.common.ActionButton
import com.eladfinish.bible.contest.ui.components.buttons.DraggableIconTextButton
import com.eladfinish.bible.contest.ui.utils.MyBackHandler
import dev.icerock.moko.resources.desc.StringDesc
import dev.icerock.moko.resources.desc.desc

@Composable
fun MainScreenDraggable(
    buttonDataList: List<Pair<ButtonType, ButtonData>>,
    onDoneDragging: (List<Pair<ButtonType, ButtonData>>) -> Unit,
    onResetOrder: () -> Unit,
    showToast: (StringDesc) -> Unit,
    hebrewGender: HebrewGender,
    onBackPressed: () -> Unit,
) {
    MyBackHandler {
        onBackPressed()
    }

    MainScreenDraggableContent(
        buttonDataList = buttonDataList,
        hebrewGender = hebrewGender,
        onDoneDragging = onDoneDragging,
        onResetOrder = onResetOrder,
        showToast = showToast,
    )
}

@Composable
private fun MainScreenDraggableContent(
    buttonDataList: List<Pair<ButtonType, ButtonData>>,
    hebrewGender: HebrewGender,
    onDoneDragging: (List<Pair<ButtonType, ButtonData>>) -> Unit,
    onResetOrder: () -> Unit,
    showToast: (StringDesc) -> Unit,
) {
    val data = remember { mutableStateOf(buttonDataList) }

    val list = buttonDataList.mapIndexed { index, pair ->
        SortableData(id = index, value = pair)
    }
    val toastText =
        SharedRes.strings.draggable_item_regular_click.desc().personalizeGender(
            hebrewGender
        )
    VerticalReorderGrid(
        data = list,
        count = 2,
        itemContent = { (_: Int, pair: Pair<ButtonType, ButtonData>) ->
            val buttonData = pair.second
            DraggableIconTextButton(
                modifier = Modifier,
                stringResource = buttonData.stringResource,
                icon = buttonData.icon,
                hebrewGender = hebrewGender,
            )
        },
        doneButton = {
            ActionButton(
                stringResource = SharedRes.strings.dragging_done,
                onClick = {
                    onDoneDragging(data.value)
                },
                hebrewGender = hebrewGender,
            )
        },
        resetButton = {
            ActionButton(
                stringResource = SharedRes.strings.dragging_reset,
                onClick = {
                    onResetOrder()
                },
                hebrewGender = hebrewGender,
            )
        },
        onItemClick = {
            showToast(toastText)
        },
        onListChanged = { updatedList ->
            data.value = updatedList.map { it.value }
        }
    )
}

@Preview
@Composable
private fun MainScreenDraggableContentPreview() {
    MainScreenDraggableContent(
        buttonDataList = ButtonType.entries.map { it.toButtonData() },
        hebrewGender = HebrewGender.MALE,
        onDoneDragging = {},
        onResetOrder = {},
        showToast = {},
    )
}
